module.exports = __webpack_public_path__ + "img/forgot-email-ic.0da95f7a.svg";